import { render, staticRenderFns } from "./download-status-list-item.vue?vue&type=template&id=8573e498&scoped=true&"
import script from "./download-status-list-item.vue?vue&type=script&lang=js&"
export * from "./download-status-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8573e498",
  null
  
)

export default component.exports